<template>
  <div>
    <transition name="modal-fade">
      <div
        v-show="modalVisible"
        @click="closeModal"
        class="modal-backdrop">
        <div class="modal"
            @click.stop
            role="dialog"
            aria-labelledby="modalTitle"
            aria-describedby="modalDescription"
            :class="modalType"
            >
            <!-- toolbar -->
            <div slot="toolbar" class="rg-toolbar">
              <div class="rg-toolbar-content">

                <span class="rg-toolbar-title">
                  <slot name="toolbar-title"></slot>
                </span>
                <div class="rg-spacer"></div>

                <slot name="toolbar-content"></slot>
                <!-- v-ripple -->
                <div class="rg-btn"
                  @click="closeModal">
                  <i aria-hidden="true" class="rg-icon material-icons">close</i>
                </div>
              </div>
            </div>
            <!-- toolbar -->

            <section
              class="modal-body"
              id="modalDescription">
            <slot name="body">
            </slot>
            </section>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'modal',

  props: {
    modalType: String,
    modalId: String,
    modalVisible: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    showModal() {
      this.modalVisible = true;
    },
    closeModal() {
      this.$bus.$emit('modal-close-event', this.modalId);
      // this.modalVisible = false;
    },
  },
};
</script>

<style lang="less">
  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }

  .modal-backdrop {
    position: fixed;
    z-index: 10;
    height: 100vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .modal-header{
    padding: 15px;
    display: flex;
  }

  .modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-body {
    position: relative;
    padding: 16px 8px;
    overflow-y: auto;
    padding-bottom: 100px; // Room to scroll past Kofi button
  }

  .top-sheet {
    align-self: flex-start;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }

  .bottom-sheet {
      align-self: flex-end;
      width: 100%;
      height: 70%;
      min-height: 250px;
      .modal-body {
        overflow-y: auto;
      }
  }
</style>
